import { inputCls, RowControls, AddRowButton, useRows } from "./fields";

export function SectionsEditor({ value = [], onChange }) {
  const { edit, remove, move } = useRows(value, onChange);
  return (
    <div className="space-y-4" data-testid="sections-editor">
      {value.map((s, i) => (
        <div key={i} className="border border-neutral-200 rounded-lg p-5 bg-neutral-50/60">
          <div className="flex items-center justify-between mb-3">
            <span className="font-playfair italic text-indigo-800">Section {String(i + 1).padStart(2, "0")}</span>
            <RowControls index={i} total={value.length} onMove={move} onRemove={remove} testid="section" />
          </div>
          <input
            value={s.heading}
            onChange={(e) => edit(i, { heading: e.target.value })}
            placeholder="Section heading"
            data-testid={`section-heading-${i}`}
            className={`${inputCls} font-playfair text-base mb-3`}
          />
          <textarea
            rows={5}
            value={s.body}
            onChange={(e) => edit(i, { body: e.target.value })}
            placeholder="Section body"
            data-testid={`section-body-${i}`}
            className={`${inputCls} resize-y leading-relaxed`}
          />
        </div>
      ))}
      <AddRowButton label="Add section" testid="add-section-button" onClick={() => onChange([...value, { heading: "", body: "" }])} />
    </div>
  );
}

export function FeatureRowsEditor({ value = [], onChange, labelA, labelB }) {
  const { edit, remove, move } = useRows(value, onChange);
  return (
    <div className="space-y-3" data-testid="feature-rows-editor">
      <div className="hidden sm:grid grid-cols-[1.2fr_1fr_1fr_auto] gap-3 text-xs font-semibold uppercase tracking-wider text-neutral-500">
        <span>Feature</span><span>{labelA || "Product A"}</span><span>{labelB || "Product B"}</span><span className="w-[92px]" />
      </div>
      {value.map((r, i) => (
        <div key={i} className="grid grid-cols-1 sm:grid-cols-[1.2fr_1fr_1fr_auto] gap-3 items-center">
          <input value={r.feature} onChange={(e) => edit(i, { feature: e.target.value })} placeholder="Feature" data-testid={`feature-name-${i}`} className={inputCls} />
          <input value={r.a} onChange={(e) => edit(i, { a: e.target.value })} placeholder={labelA || "Product A"} data-testid={`feature-a-${i}`} className={inputCls} />
          <input value={r.b} onChange={(e) => edit(i, { b: e.target.value })} placeholder={labelB || "Product B"} data-testid={`feature-b-${i}`} className={inputCls} />
          <RowControls index={i} total={value.length} onMove={move} onRemove={remove} testid="feature" />
        </div>
      ))}
      <AddRowButton label="Add feature row" testid="add-feature-row-button" onClick={() => onChange([...value, { feature: "", a: "", b: "" }])} />
    </div>
  );
}
